export const FETCH_LOGIN_USER = 'fetchLoginUser'
export const FETCH_SITE_INFO = 'fetchSiteInfo'
export const FETCH_MAINTENANCE = 'fetchMaintenance'
export const CHANGE_TOP_FONT_SCALE = 'changeTopFontScale'
